import type { ReactNode } from 'react';
import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';

interface IFeatureHeaderProps {
  icon: ReactNode;
  title: string;
  maxWidth?: string | number;
}

export const FeatureHeader = ({
  icon,
  title,
  maxWidth = '760px',
}: IFeatureHeaderProps) => (
  <Stack width="100%" maxWidth={maxWidth} spacing={2}>
    <Stack direction="row" alignItems="center" gap={1}>
      {icon}
      <Text variant="h5" mb={0}>
        {title}
      </Text>
    </Stack>
    <Divider sx={{ width: '100%' }} />
  </Stack>
);
